<template>
    <div class="echart-chart-block">
        <div class="chart-info">
            <div class="chart-title" v-if="title">
                {{ title }}
            </div>
        </div>
        <div :id="chartID" :class="chartTall ? 'chart-tall' : 'chart'"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts'
import ecTools from '@/echarts/echarts-tools'

export default {
    props: {
      chartID: {
          type: String,
          required: true,
      },
      chartTall: {
          type: Boolean,
          default: false,
      },
      title: {
          type: String,
          default: '',
      },
      yData: {
          type: Array,
          default: function () { return [] }
      },
      yData_list: {
          type: Array,
          default: function () { return [] }
      },
      xData: {
          type: Array,
          default: function () { return [] }
      },
      showToolbox: {
          type: Boolean,
          default: true,
      },
      xAxisName: { type: String, },
      yAxisName: { type: String, },
      xAxisUseDateFormat: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
          theChart: undefined,
          lastValue: undefined,
      }
    },
    mounted () {
      this.theChart = echarts.init(document.getElementById( this.chartID ));
      this.drawChartPrepare();
    },
    computed: {
      ...mapState({
          'language': state => state.user.language,
          'screenWidth': state => state.system.screenWidth,
          'contentWidth': state => state.system.contentWidth,
      }),
    },
    watch: {
      // 偵測到 [ 語言 ] 變動就更新圖表
      language ()
      {
          this.drawChartPrepare();
      },

      // 偵測到 [ 時間 ] 變動就更新圖表
      time ()
      {
          this.drawChartPrepare();
      },

      // 偵測到 [ 視窗寬度 ] 變動就更新圖表
      screenWidth (val, oldVal)
      {
          if ( val != oldVal && this.theChart != undefined )
          {
              this.theChart.resize()
          }
      },
      // 偵測到 [ 版面寬度 ] 變動就更新圖表
      contentWidth (val, oldVal)
      {
          if ( val != oldVal && this.theChart != undefined )
          {
              this.theChart.resize()
          }
      },
    },
    methods: {

      drawChartPrepare ()
      {
        this.drawChart( this.theChart,
                        this.showToolbox );
      },

      drawChart ( chart,
                  _showToolbox )
      {
        let _title = ''
        if (this.title) {
          _title = this.title
        }
        else {
          _title = `${ this.xData[0] } - ${ this.xData[this.xData.length - 1] }`
        }

        let _xData = []
        if (this.xAxisUseDateFormat) {
          _xData = ecTools.get_XAxis_day(this.xData.length, this.xData, `MM/DD`);
        }
        else _xData = this.xData

        let _series = []

        if (this.yData) {
          let _a_set = {
            name: 'times',
            type: 'line',
            data: this.yData,
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            markLine: {
              data: [{ type: 'average', name: 'Avg' }]
            }
          }

          _series.push(_a_set)
        }

        if (this.yData_list) {
          this.yData_list.forEach( _data => {

            let _a_set = {
              name: 'times',
              type: 'line',
              data: _data,
              markPoint: {
                data: [
                  { type: 'max', name: 'Max' },
                  { type: 'min', name: 'Min' }
                ]
              },
              markLine: {
                data: [{ type: 'average', name: 'Avg' }]
              }
            }

            _series.push(_a_set)
          })
        }

        let _xAxisName = this.xAxisName;
        let _yAxisName = this.yAxisName;
        let option = {
          title: {
            show: true,
            text: _title,
            left: 'center',
          },
          toolbox: ecTools.createToolbox( this.chartID, _title + ' - Line Chart', _showToolbox ),
          xAxis:
          [{
              gridIndex: 0,
              type: 'category',
              name: _xAxisName,
              nameGap: 25,
              nameLocation: 'center',
              data: _xData,
              boundaryGap: true,
              splitArea: { show: false },
              splitLine: { show: false },
          }],
          yAxis:
          [{
              gridIndex: 0,
              name: _yAxisName,
              nameGap: 10,
              splitArea: { show: false },
          }],
          series: _series,
          animation: true,
        };
        chart.setOption(option);
    },

  }

}
</script>

<style lang="scss" scoped>



</style>
